export var assign_group = "\n#ifdef dGeometryType_textureMesh\n    float group = unpackRGBToInt(readFromTexture(tGroup, VertexID, uGeoTexDim).rgb);\n#else\n    float group = aGroup;\n#endif\n";
//# sourceMappingURL=assign-group.glsl.js.map